import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from './Icon';

/**
 * Right-side sliding panel. Ported from D:\campaigning-system\src\components\ui\Drawer.tsx.
 * Renders via a portal to document.body (so `fixed` stays viewport-relative), wrapped in a
 * background-less `.campaign-os` scope so the Hanken font + glass tokens still apply outside the shell.
 */
export function Drawer({ open, onClose, children, width = 'max-w-2xl' }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;
  return createPortal(
    <div className="campaign-os" style={{ background: 'none', minHeight: 0 }}>
      <div className="fixed inset-0 z-[60]">
        <div className="absolute inset-0 bg-[rgba(35,40,36,0.28)] backdrop-blur-[3px] animate-fade-in" onClick={onClose} />
        <div
          role="dialog"
          aria-modal="true"
          className={`absolute inset-y-0 right-0 flex w-full ${width} flex-col border-l border-white/70 bg-[rgba(247,246,241,0.86)] shadow-cos-glass-lg backdrop-blur-[22px] animate-slide-in-right`}
        >
          {children}
        </div>
      </div>
    </div>,
    document.body
  );
}

export function DrawerClose({ onClose }) {
  return (
    <button
      onClick={onClose}
      aria-label="Close panel"
      className="grid h-9 w-9 place-items-center rounded-lg text-cos-ink-muted transition-colors hover:bg-white/70 hover:text-cos-ink"
    >
      <Icon name="close" className="text-[20px]" />
    </button>
  );
}

export default Drawer;
